import React, { useState } from "react";
import { Card, Tabs } from "antd";
import "./itReports.css"

const { TabPane } = Tabs;

const ITReports = () => {
    const [activeTab, setActiveTab] = useState("1");

    const handleTabChange = (key) => {
        setActiveTab(key);
    };

    return (
        <div className="it-reports-container">
            <Card className="reports-card">
                <label style={{ fontSize: "18px", fontWeight: "600", marginBottom: "16px", fontFamily: "Inter" }}>Reports</label>
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    className="reports-tabs"
                >
                    {/* First Tab - IT Recruitment Team Report */}
                    <TabPane tab="IT Recruitment Team Report" key="1">
                        <iframe
                            src="https://app.powerbi.com/view?r=eyJrIjoiNWY4NzUzYmYtZDg0Mi00ODc2LThiZDItMmVjMDU0NWQyMWM4IiwidCI6IjFiNTdjODJlLTc4NGQtNDEwNS1hMDQ5LTVhNDJhOThkZTRlOCJ9"
                            title="IT Recruitment Team Report"
                            style={{ width: "100%", height: "60vh", border: "none" }}
                        />
                    </TabPane>

                    {/* Second Tab - Report 2 */}
                    <TabPane tab="Coromandel Dashboard" key="2">
                        <iframe
                            src="https://app.powerbi.com/view?r=eyJrIjoiYTIyMmVjMjItMDgyNy00OGNiLTg0MjktNjVkZTgxOGUyZDQyIiwidCI6IjFiNTdjODJlLTc4NGQtNDEwNS1hMDQ5LTVhNDJhOThkZTRlOCJ9"
                            title="Coromandel Dashboard"
                            style={{ width: "100%", height: "60vh", border: "none" }}
                        />
                    </TabPane>

                    {/* Third Tab - Report 3 */}
                    <TabPane tab="ORR Dashboard " key="3">
                        <iframe
                            src="https://app.powerbi.com/view?r=eyJrIjoiNDMyNTM2ZjktZTg0MC00ZGQ2LTgxODktNWI4NTU0NDcwYWY0IiwidCI6IjFiNTdjODJlLTc4NGQtNDEwNS1hMDQ5LTVhNDJhOThkZTRlOCJ9"
                            title="ORR Dashboard "
                            style={{ width: "100%", height: "60vh", border: "none" }}
                        />
                    </TabPane>

                    <TabPane tab="ORR Dashboard 2.0" key="4">
                        <iframe
                            src="https://app.powerbi.com/view?r=eyJrIjoiMmZhNmQ0NTQtNTQwNC00MGE2LWFlYzAtY2FkMjY1NDQ1NTViIiwidCI6IjFiNTdjODJlLTc4NGQtNDEwNS1hMDQ5LTVhNDJhOThkZTRlOCJ9"
                            title="ORR Dashboard 2.0"
                            style={{ width: "100%", height: "60vh", border: "none" }}
                        />
                    </TabPane>

                    <TabPane tab="Aadhar Home Loans" key="5">
                        <iframe
                            src="https://app.powerbi.com/view?r=eyJrIjoiZWUzYmY0YTQtMWU0My00YjIwLWJjZTktYWVjOGFhMDQ1ZTBhIiwidCI6IjFiNTdjODJlLTc4NGQtNDEwNS1hMDQ5LTVhNDJhOThkZTRlOCJ9"
                            title="Aadhar Home Loans"
                            style={{ width: "100%", height: "60vh", border: "none" }}
                        />
                    </TabPane>
                </Tabs>
            </Card>
        </div>
    );
};

export default ITReports;
